import React, { useState, useEffect } from "react";

const DoctorFilter = ({ doctors, specialties, onFilter }) => {
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [selectedWilaya, setSelectedWilaya] = useState("");
  const [selectedCommune, setSelectedCommune] = useState("");
  const [searchName, setSearchName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const wilayas = Array.from(
    new Set(
      doctors.map((doctor) => doctor.businessInfo?.wilaya).filter(Boolean)
    )
  );

  const communes = Array.from(
    new Set(
      doctors
        .filter((doctor) =>
          selectedWilaya ? doctor.businessInfo?.wilaya === selectedWilaya : true
        )
        .map((doctor) => doctor.businessInfo?.commune)
        .filter(Boolean)
    )
  );

  useEffect(() => {
    const filteredDoctors = doctors.filter((doctor) => {
      const matchesSpecialties =
        selectedSpecialties.length === 0 ||
        selectedSpecialties.includes(doctor.speciality);

      const matchesWilaya =
        !selectedWilaya || doctor.businessInfo?.wilaya === selectedWilaya;

      const matchesCommune =
        !selectedCommune || doctor.businessInfo?.commune === selectedCommune;

      const matchesName =
        !searchName ||
        doctor.name.toLowerCase().includes(searchName.toLowerCase());

      return (
        matchesSpecialties && matchesWilaya && matchesCommune && matchesName
      );
    });

    onFilter(filteredDoctors);
  }, [selectedSpecialties, selectedWilaya, selectedCommune, searchName]);

  const handleSpecialtyChange = (specialtySlug) => {
    setSelectedSpecialties((prev) =>
      prev.includes(specialtySlug)
        ? prev.filter((slug) => slug !== specialtySlug)
        : [...prev, specialtySlug]
    );
  };

  const resetFilters = () => {
    setSelectedSpecialties([]);
    setSelectedWilaya("");
    setSelectedCommune("");
    setSearchName("");
  };

  return (
    <div className="w-full bg-slate-100 border border-mainColor rounded-xl calendar-section py-3 px-4 mb-8">
      <div className="flex lg:block w-full justify-between items-center text-md sm:text-xs">
        <div className=" lg:mb-2 relative w-full lg:p-2 justify-center items-center">
          <button
            className="w-full p-2 border rounded-md bg-white text-left"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {selectedSpecialties.length > 0
              ? specialties
                  .filter((s) => selectedSpecialties.includes(s.slug))
                  .map((s) => s.name)
                  .join(", ")
              : "Toutes spécialités - جميع التخصصات"}
          </button>
          {isDropdownOpen && (
            <div className="absolute z-10 w-full bg-white border rounded-md max-h-80 overflow-y-auto shadow-md">
              {specialties.map((specialty) => (
                <label
                  key={specialty._id}
                  className="block px-3 py-2 cursor-pointer hover:bg-gray-100"
                >
                  <input
                    type="checkbox"
                    className="mr-2"
                    value={specialty.slug}
                    checked={selectedSpecialties.includes(specialty.slug)}
                    onChange={() => handleSpecialtyChange(specialty.slug)}
                  />
                  {specialty.name}
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="flex justify-center">
          <div className="mx-2 items-center justify-center w-48 sm:w-full">
            <select
              className="w-full p-1 border rounded-md"
              value={selectedWilaya}
              onChange={(e) => setSelectedWilaya(e.target.value)}
            >
              <option value="">Wilayas</option>
              {wilayas.map((wilaya, index) => (
                <option key={index} value={wilaya}>
                  {wilaya}
                </option>
              ))}
            </select>
          </div>

          <div className="mx-2 items-center justify-center w-48 sm:w-full">
            <select
              className="w-full p-1 border rounded-md"
              value={selectedCommune}
              onChange={(e) => setSelectedCommune(e.target.value)}
            >
              <option value="">Communes</option>
              {communes.map((commune, index) => (
                <option key={index} value={commune}>
                  {commune}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center sm:mt-4">
          <div className="mx-2 items-center justify-center w-48 sm:w-full">
            <input
              type="text"
              className="w-full p-2 border rounded-md"
              placeholder="nom du docteur ..."
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </div>
          <div className="mx-2 flex items-center justify-center">
            <button className="main-btn2" onClick={resetFilters}>
              Réinitialiser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorFilter;
